
const baseSpaceUnit = 5;


export const vfxTheme = {
    spacing: baseSpaceUnit,
    spaceUnits: {
        sp00: 0,
        sp01: baseSpaceUnit,
        sp02: baseSpaceUnit * 2,
        sp03: baseSpaceUnit * 3,
        sp04: baseSpaceUnit * 6,
        sp05: baseSpaceUnit * 12,
    },
    palette: {
        primary: {
            main: "#01568c",
            light: "#f2f6ff",
            dark: "#183ba2",
            denim: "#0C67A6",
        },
        secondary: {
            main: "#e00034", //#f8b333
            light: "#FFE3EA",
            dark: "#c1012e",
        },
        background: { default: "#fff", grey: "#E5E5E5" },
        blueGreys: {
            bg50: "#E6E7E9",
            bg100: "#B1B4B9",
            bg200: "#9DA1A8",
            bg300: "#898E96",
            bg400: "#757B85",
            bg500: "#656B74",
            bg600: "#555A63",
            bg700: "#444A52",
            bg800: "#343941",
            bg900: "#242930",
        },
        lightGreens: {
            lg50: "#F2F4D4",
            lg100: "#D6DCA1",
            lg200: "#BBC56E",
            lg300: "#9FAD3B",
            lg400: "#8F9B35",
            lg500: "#747C37",
            lg600: "#62682D",
            lg700: "#505523",
            lg800: "#3E4118",
            lg900: "#2C2D0E",
        },
        oranges: {
            o50: "#F2E4D7",
            o100: "#E5C8AC",
            o200: "#D7AC81",
            o300: "#CA8F55",
            o400: "#BC732A",
            o500: "#A56525",
            o600: "#8D5621",
            o700: "#76481C",
            o800: "#5E3918",
            o900: "#472B13",
        },
        reds: {
            r50: "#EAD6D9",
            r100: "#E2B3BD",
            r200: "#DA90A2",
            r300: "#D16C86",
            r400: "#C9496A",
            r500: "#B7405C",
            r600: "#A5364F",
            r700: "#942D41",
            r800: "#822433",
            r900: "#5B1A27",
            error: "#F44336",
        },
        purples: {
            p50: "#ECE4EF",
            p100: "#D5C6DB",
            p200: "#BEA9C6",
            p300: "#A78BB2",
            p400: "#906D9E",
            p500: "#7F5D8C",
            p600: "#6F4D7A",
            p700: "#5E3E68",
            p800: "#4E2E56",
            p900: "#3D1E44",
        },
        teals: {
            t50: "#D9EDED",
            t100: "#AFD8D8",
            t200: "#86C2C3",
            t300: "#5DADAE",
            t400: "#339799",
            t500: "#2C8283",
            t600: "#266D6D",
            t700: "#1F5758",
            t800: "#194242",
            t900: "#122D2C",
        },
        blues: {
            b50: "#E1E9EF",
            b100: "#BAD1E4",
            b200: "#93BAD9",
            b300: "#6BA2CD",
            b400: "#448BC2",
            b500: "#1D73B7",
            b600: "#1B5C99",
            b700: "#19447A",
            b800: "#143155",
            b900: "#0E1E30",
        },
        text: {
            primary: "#333333",
            secondary: "#727171",
        },
        valid: {
            main: "#3F9700",
            light: "#e1fcce",
        },
        post: {
            main: "#fffbed",
        },
        warning: {
            main: "#b8860b",
        },
        white: "#ffffff",
        black: "#000",
    },
    shape: {
        borderRadius: baseSpaceUnit,
    },
    fontWeights: {
        light: 300,
        regular: 400,
        medium: 500,
        semiBold: 600,
        bold: 700,
        extraBold: 800,
    },
    fontFamily: "Montserrat",
    shadowTypes: {
        buttonHover: "0 2px 4px 0 rgba(0, 0, 0, 0.5)",
        buttonFocus: "0 0 0px 2px #fff, 0 0 3px 4px rgba(59, 86, 166, 0.5)",
        popover: "0 0 15px 5px rgba(0, 0, 0, 0.25)",
        imageHover: "0 2px 6px 0 rgba(0, 0, 0, 0.5)",
        container: "0 0 5px rgba(0, 0, 0, 0.5)",
    },
    typography: {
        fontFamily: `Montserrat`,
    },
    drawer: {
        zIndex: 1050,
    },
};
